import { useField } from "formik";
import React from "react";
import styled from "@emotion/styled";

import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
import RemoveIcon from "@material-ui/icons/Remove";
import Tooltip from "@material-ui/core/Tooltip";

import CardActions from "@material-ui/core/CardActions";
import CardActionArea from "@material-ui/core/CardActionArea";

import {
  RadioCard,
  RadioCardMedia,
  RadioCardContent,
  TooltipContent,
} from "./Radio";

const RoundButton = styled(Button)(() => ({
  width: 25,
  height: 25,
  minHeight: 25,
  minWidth: 25,
  padding: 0,
  borderRadius: "50%",
  boxShadow: "none",
  svg: {
    width: "0.7em",
    height: "0.7em",
  },
}));

const NumberCardOption = ({ option }) => {
  const { description, images, code } = option;
  const props = { name: code };
  const [field, meta, helpers] = useField(props);

  return (
    <RadioCard
      onClick={() => {
        const currentVal = parseInt(field.value, 10);
        if (!currentVal) {
          helpers.setValue(1);
          helpers.setTouched(true);
          return;
        }
      }}
      selected={!!field.value}
      disabled={!option?.available}
    >
      <Tooltip
        title={<TooltipContent>{description}</TooltipContent>}
        disableHoverListener={!description}
        arrow
      >
        <>
          <CardActionArea>
            {images[0]?.url && (
              <RadioCardMedia
                image={images[0]?.url}
                title="Contemplative Reptile"
              />
            )}
            <RadioCardContent>
              <Typography gutterBottom variant="subtitle2" component="h2">
                {option.name}
              </Typography>
            </RadioCardContent>
          </CardActionArea>
          <CardActions>
            <RoundButton
              variant="outlined"
              onClick={() => {
                const currentVal = parseInt(field.value, 10);
                if (!currentVal || currentVal <= 1) {
                  helpers.setValue("");
                  return;
                }
                helpers.setValue(currentVal - 1);
              }}
            >
              <RemoveIcon />
            </RoundButton>
            <TextField
              style={{ width: 35 }}
              type="number"
              disabled
              inputProps={{
                ...field,
                value: field.value === undefined ? "" : field.value,
                name: option.code,
                style: { textAlign: "end" },
              }}
            />
            <RoundButton
              variant="outlined"
              onClick={() => {
                const currentVal = parseInt(field.value, 10);
                helpers.setTouched(true);
                if (!currentVal) {
                  helpers.setValue(1);
                  return;
                }
                helpers.setValue(currentVal + 1);
              }}
            >
              <AddIcon />
            </RoundButton>
          </CardActions>
        </>
      </Tooltip>
    </RadioCard>
  );
};

export default NumberCardOption;
